export const xjtypes = [
    {code:'1',name:'公开招标'},
    {code:'2',name:'定向采购'},
    {code:'3',name:'竞争性磋商'},
]

export const noticeType = [
    {code:'1',name:'企业公告'},
]

// 项目类型
export const projectTypeOption = [
    {code:'1',name:'自营项目'},
    {code:'2',name:'委托项目'},
]
